import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';
import { ConfigService } from './../common/services/config.service';
import { SharedService } from './../common/services/sharedService';
import { Location } from '@angular/common';
@Directive({
    selector: '[reloadEvent]',
})
export class ReloadDirective {
    constructor(private el: ElementRef,
        private renderer: Renderer2,
        private _sharedservice: SharedService,
        private location: Location) {
    }
    @HostListener('window:unload') onWindowUnload() {
        console.log("reload");
        let prdcode = this._sharedservice.getData('prodCode');
        if (prdcode && typeof (prdcode) !== 'object') {
            window.name = prdcode;
        }
    }
}
